module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('category.label')
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.from.categories,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha"
    },
    model: {
      value: (_vm.newItem.from.category),
      callback: function($$v) {
        _vm.$set(_vm.newItem.from, "category", $$v)
      },
      expression: "newItem.from.category"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('departments.label'),
      "columns": 3
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.to.departments,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "label": "label",
      "track-by": "code"
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  })], 1), _vm._v(" "), (_vm.newItem.to.department !== null && _vm.showCategories) ? _c('form-group', {
    attrs: {
      "label": _vm.$t('category.label'),
      "columns": 3
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.to.categories,
      "selectLabel": "",
      "selectedLabel": "",
      "placeholder": "Escolha",
      "label": "label",
      "track-by": "code"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-1@md vertical-center"
  }, [_c('i', {
    staticClass: "i-arrow icon-arrow-right center"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83047710","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/tool/api/marketplace/cnova/CategorizationAddItem.vue
// module id = 3345
// module chunks = 0